import axiosAuthAPI from './axiosAuthAPI';
import config from '../config';

class IntroVideoService {
  /**
   * Get signed URL for video blob
   * @param {string} blobPath - The blob path for the video
   * @returns {Promise<Object>} - Response with signed URL and metadata
   */
  async getVideoSignedUrl(blobPath) {
    try {
      const response = await axiosAuthAPI.post(
        '/api/v1/auto/video/blob/signed-url',
        {
          blob_path: blobPath,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error getting video signed URL:', error);
      throw error;
    }
  }

  /**
   * Check if user has watched the intro video
   * @param {string} organizationName - The organization name
   * @returns {Promise<Object>} - Response with watched status
   */
  async checkIntroVideoStatus(organizationName) {
    try {
      const response = await axiosAuthAPI.get(
        `/api/v1/auto/intro-video/status?organization_name=${organizationName}`
      );
      return response.data;
    } catch (error) {
      console.error('Error checking intro video status:', error);
      throw error;
    }
  }

  /**
   * Mark intro video as watched
   * @param {string} organizationName - The organization name
   * @returns {Promise<Object>} - Response with success status
   */
  async markIntroVideoAsWatched(organizationName) {
    try {
      const response = await axiosAuthAPI.post(
        '/api/v1/auto/intro-video/mark-watched',
        {
          organization_name: organizationName,
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error marking intro video as watched:', error);
      throw error;
    }
  }

  /**
   * Get intro video URL from config
   * @returns {string} - Direct URL for intro video
   */
  getIntroVideoUrl() {
    return config.introVideo.url;
  }
}

export default new IntroVideoService();
